import {Component, Vue, Watch} from 'vue-property-decorator'
import {UserModule} from '@/store/modules/user'
import {
    gettHeaderByType, settHeaderByType
} from '@/api/common'
import {formatDate} from '@/utils/timeFilter'
import {menuBtn} from '@/utils/menu_level2_button'
import {delNullProperty} from '@/utils/index'
import realTimeSokcet from '@/utils/socket.io'
import {
    getFinanceContractTemplateById,
    delFinanceContractTemplateById,
    getFinanceContractTemplateList,
    generatePdf
} from "@/api/financial-center";

@Component({})
export default class SchoolList extends Vue {
    socket: any = null
    tableHeadPopoverShow = false
    tableData: any = []
    tableHeader: any = []
    checkTableRow: any = []
    tableHeadFilter = {
        souCourseTypeIdList: [],
        souCoursePrice: '',
        dissertationType: '',
        companyName: '',
        name: '',
    }
    page = 1
    limit = 20
    total = 0


    addDialog = false
    sendBackSelect = ''
    schoolName = ''
    schoolTypesList = [
        {value: '0', name: '海外大学'},
        {value: '1', name: '国内大学'},
        {value: '2', name: '中学'}
    ]
    schoolType = ''
    loading = false
    sendBackClueID: number; // 退户线索id
    menuBtn = menuBtn
    deleteDialog = false
    // cancelTabkBackClueId: number
    // sendBackDialogConfirmButtonDisabled = false
    // rowData = null
    // delType: any = null
    // repeatName: any = null
    // uploadUrl: any = null
    // uploadDialog = false
    // uploadData = null
    exportButtonDisabled = false
    timer = null

    typeList = [
        {value: 1, label: '国外小组科研'},
        {value: 2, label: '国内1对1'},
        {value: 3, label: '国外1对1'},
        {value: 4, label: '名校实验室'},
        {value: 5, label: 'AI HUB'},
        {value: 6, label: '全球华人导师'},
        {value: 27, label: '博雅计划-在线'},
        {value: 30, label: 'IEPQ线上项目'},
        {value: 31, label: '竞赛'},
        {value: 32, label: '全球华人导师-香港'},
        {value: 38, label: '海外导师线下项目'},
        {value: 39, label: '国内导师线下项目'},
        {value: 40, label: '竞赛1v1'},
        {value: 42, label: 'IEPQ 1v1'},
        {value: 44, label: '全球华人导师-海外'},
        {value: 45, label: '企业导师远程实训'},
        {value: 47, label: '博雅计划-线下'},
        {value: 48, label: 'IEPQ 1v3'},
        {value: 49, label: '专业选修课'},
        {value: 50, label: 'IEPQ线下项目'},
        {value: 51, label: 'CERTIPORT认证课程'},
        {value: 52, label: '境外游学项目'},
        {value: 53, label: '竞赛线下（营地）'},
        {value: 54, label: '竞赛线下（研学）'},
    ]
    draggableList = []
    draggableListChange = []
    vdaH = 0
    popHeight = 0
    tableKey = Math.random()
    deleteId = ''

    // computed
    get userList() {
        return UserModule.userList
    }

    get userId() {
        return UserModule.userId
    }

    // created
    created() {
        this.getTableHeader()
        // if (this.userId) this.initSocket()
        // const h = document.documentElement.clientHeight || document.body.clientHeight;
        // this.vdaH = h - 260;
        // this.popHeight = this.vdaH
        // if(process.env.NODE_ENV === 'development') {
        //     this.uploadUrl = process.env.VUE_APP_BASE_CRM_API_PROXY + '/tools/importSchool'
        // } else {
        //     if(window.location.origin.includes('-testserver')) {
        //         this.uploadUrl = process.env.VUE_APP_DEV_API + '/tools/importSchool'
        //     } else {
        //         this.uploadUrl = process.env.VUE_APP_MASTER_API + '/tools/importSchool'
        //     }
        // }

    }

    // 转化项目类型
    changeSouCourseType(id) {
        let label = ''
        this.typeList.forEach((item: any) => {
            if (item.value == id) {
                label = item.label
            }
        })
        return label
    }


    getRowKeys(row: any) {
        return row.id
    }

    async draggableEnd() {
        this.draggableList = this.draggableListChange
        const newArr: object = this.draggableList.filter(item =>
            item.isShow === true
        )
        if ((newArr as []).length > 0) {
            await settHeaderByType({headerIds: this.draggableList, types: 18})
            this.$message.success('设置成功')
            this.tableHeadPopoverShow = false
            this.getTableHeader()
        } else {
            this.$message.error('至少保留一个表头')
        }
    }

    doCancel() {
        this.draggableListChange = JSON.parse(JSON.stringify(this.draggableList))
        this.tableHeadPopoverShow = false
    }

    changeTable(val) {
        const newArr = []
        this.draggableListChange.forEach(item => {
            if (item.isShow === true) {
                newArr.push(item)
            }
        })
        if (newArr.length == 1) {
            newArr.forEach(item => {
                item.isDisBtn = true
            })
        } else {
            newArr.forEach(item => {
                item.isDisBtn = false
            })
        }
    }

    async getTableData() {
        this.loading = true

        const obj = {...this.tableHeadFilter, page: this.page, limit: this.limit}
        const data: any = await getFinanceContractTemplateList(delNullProperty(obj))
        this.tableData = data.financeContractTemplateList
        this.total = data.allNum
        this.tableKey = Math.random()
        this.$nextTick(() => {
            (this.$refs.multipleTable as HTMLFormElement).doLayout();
            (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
        });
        this.loading = false

    }


    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getTableData()
        }, 1000)
    }

    pageSizeChange(limit: number) {
        this.limit = limit
        this.getTableData()
    }

    clickTableRow(row: any, col: any) {
        // if (!this.menuBtn(34)) return
        if (col.label !== '操作' ) {
            const win = window.open(window.location.origin + this.$route.matched[0].path + '/contractTemplateInfo?contractTemplateId=' + row.id)
            const time = setInterval(() => {
                if (win.closed) {
                    this.getTableData()
                    clearInterval(time)
                }
            }, 500)
        }
    }


    editSchool(row: any) {
        let url = window.location.origin + this.$route.matched[0].path
        url += '/newContractTemplate?contractTemplateId=' + row.id
        this.openPage(url)
    }

    deleteSchool(id) {
        console.log('id',id)
        this.deleteId = id
        this.deleteDialog = true
    }

    doDeleteCancel() {
        this.deleteDialog = false
    }

    async doDelete() {
        await delFinanceContractTemplateById({id: this.deleteId})
        this.$message.success('删除成功')
        this.deleteDialog = false
        this.getTableData()
    }

    // 新建合同模板
    addContractTemplate() {
        let url = ''
        url = this.$route.matched[0].path + '/newContractTemplate'
        this.openPage(url)
    }

    openPage(url: string) {
        const win = window.open(url, '_blank')
        const timer = setInterval(() => {
            if (win.closed) {
                clearInterval(timer)
                this.getTableData()
            }
        }, 500)
    }


    async getTableHeader() {
        this.loading = true
        const data: any = await gettHeaderByType(18)
        this.draggableList = data.headerUserList
        this.tableHeader = JSON.parse(JSON.stringify(data.headerUserList))
        this.draggableListChange = JSON.parse(JSON.stringify(data.headerUserList))
        this.loading = false
        this.getTableData()
    }

    /*
    按钮权限验证
    */
    handleBtn(id: number) {
        return menuBtn(id)
    }

    /*
    *下载合同模板*/
    async download(id) {
        //   获取详情
        const data: any = await getFinanceContractTemplateById({id: id}).then((data: any) => {
            let pdfHtml = data.financeContractTemplate.detail
            pdfHtml = pdfHtml.replace('{{优惠金额}}','') // 下载去掉{{优惠金额}}

            //   生成pdf
            generatePdf({
                htmlStr: pdfHtml,
                marginTop: 50,
                marginBottom: 50,
            }).then((data1: any) => {
                const aUrl = data1.url
                // 创建a链接下载
                window.open(aUrl, '_blank')
            })
        })
    }

    // @Watch('userId')
    // handleWatchUserId() {
    //     this.initSocket()
    // }
}
